import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/help-center',
  component: Layout,
  name: 'HelpCenterManagement',
  meta: { title: '帮助中心', icon: 'i-ep:document', menu: false },
  children: [
    {
      path: 'list',
      name: 'HelpCenterList',
      component: () => import('@/views/help/center/index.vue'),
      meta: { title: '帮助中心', icon: 'i-ep:document' },
    },
    {
      path: 'create',
      name: 'HelpCenterCreate',
      component: () => import('@/views/help/center/form.vue'),
      meta: { title: '创建帮助', icon: 'i-ep:plus', menu: false, activeMenu: '/help-center/list' },
    },
    {
      path: 'edit/:id',
      name: 'HelpCenterEdit',
      component: () => import('@/views/help/center/form.vue'),
      meta: { title: '编辑帮助', icon: 'i-ep:edit', menu: false, activeMenu: '/help-center/list' },
    },
  ],
}

export default routes
